import USER_ROLES from "../../../../../../constants/userRoles.constants";

class SubjectAreaController {
    constructor(
        evaluationService,
        stepLearningGoalsService,
        learningAreaService,
        curriculumService,
        userService,
        $stateParams,
        $state,
        $mdDialog,
        $mdToast,
        $q,
    ) {
        this.evaluationId = parseInt($stateParams.id);
        this.subjectArea = "Subject Area Name";
        this.selectedSkills = [];
        this.groupedSkills = [];
        this.othersLearningGoals = [];
        this.showOthers = false;
        this.stateChangeCheck = true;
        this.stepLearningGoalsService = stepLearningGoalsService;
        this.selectedCurriculum = null;
        this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
        this.isManager = (evaluationService.currentEvaluation && evaluationService.currentEvaluation.isManager) == true;

        $q.all([
            evaluationService.getEvaluationData(this.evaluationId),
            learningAreaService.list(),
            ((this.isAdmin || this.isManager) ? curriculumService.list() : curriculumService.listNoLegacy())
        ]).then((data) => {
            this.curriculums = data[2];
            this.curriculums.forEach(curriculum => {
                curriculum.areas.forEach(area => {
                    area.grades.forEach(grade => {
                        grade.skills.forEach(skill => {
                            skill.curriculumName = curriculum.name;
                            skill.gradeName = grade.name;
                            skill.areaName = area.name;
                        });
                    })
                })
            });
            // this.filteredSkills();

            this.evaluationData = data[0];

            this.learningAreas = data[1];
            this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
            this.isManager = this.evaluationData.isManager;
            const filteredSkills = this.evaluationData.learningGoals
                .sort((prev, next) => prev.id > next.id ? 1 : -1);
            this.isFinished = evaluationService.isAfterFinish(this.evaluationData.status);
            if (this.isFinished) {
                evaluationService.getOthers('learning_goals', true, this.evaluationData.id).then((learningGoals) => {
                    this.othersLearningGoals = learningGoals;

                    //Prepare skills from Evaluator
                    filteredSkills.forEach((skill) => {
                        const myGoal = skill;
                        skill.myScore = myGoal ? myGoal.importance : null;
                        skill.scoreACount = myGoal && myGoal.importance === "A" ? 1 : 0;
                        skill.scoreNCount = myGoal && myGoal.importance === "N" ? 1 : 0;
                        skill.scoreBCount = myGoal && myGoal.importance === "B" ? 1 : 0;
                        skill.othersScores = [];
                    });

                    //Add others skills from other Evaluators
                    this.othersLearningGoals.forEach((otherPerson) => {
                        otherPerson.learningGoals.forEach(otherLearningGoal => {
                            const foundSkill = filteredSkills.find(skill => skill.skillId === otherLearningGoal.skillId);
                            if(!foundSkill) {
                                const otherSkill = {...otherLearningGoal,
                                    myScore: null,
                                    scoreACount: 0,
                                    scoreNCount: 0,
                                    scoreBCount: 0,
                                    importance: null,
                                    othersScores: []
                                };
                                filteredSkills.push(otherSkill);
                            }
                        });
                    });

                    //Calculate scores
                    filteredSkills.forEach((skill) => {
                        const myGoal = skill;
                        skill.myScore = myGoal ? myGoal.importance : null;
                        skill.scoreACount = myGoal && myGoal.importance === "A" ? 1 : 0;
                        skill.scoreNCount = myGoal && myGoal.importance === "N" ? 1 : 0;
                        skill.scoreBCount = myGoal && myGoal.importance === "B" ? 1 : 0;
                        skill.othersScores = [];

                        this.othersLearningGoals.forEach((otherPerson) => {
                            const otherGoal = otherPerson.learningGoals.find((myLearningGoal) => {
                                return myLearningGoal.skillId === skill.skillId;
                            });

                            if (otherGoal) {
                                switch (otherGoal.importance) {
                                    case("A"):
                                        skill.scoreACount++;
                                        break;
                                    case("B"):
                                        skill.scoreBCount++;
                                        break;
                                    case("N"):
                                        skill.scoreNCount++;
                                        break;
                                }
                            }
                            skill.othersScores.push({
                                username: otherPerson.user.isDeleted ? 'Deleted User' : otherPerson.user.username,
                                importance: otherGoal ? otherGoal.importance : null
                            });
                        });
                    });

                    filteredSkills.sort((prev, next) => {
                        if (prev.scoreACount > next.scoreACount) {
                            return -1;
                        } else if (prev.scoreACount < next.scoreACount) {
                            return 1;
                        } else if (prev.scoreBCount > next.scoreBCount) {
                            return -1;
                        } else if (prev.scoreBCount < next.scoreBCount) {
                            return 1;
                        } else if (prev.scoreNCount > next.scoreNCount) {
                            return -1;
                        } else if (prev.scoreNCount < next.scoreNCount) {
                            return 1;
                        }
                        return 0;
                    });
                });
            }
            this.defineSelectedSkills(filteredSkills);
            this.filteredSkills();
            this.groupedSkillsPristine = JSON.parse(angular.toJson(this.groupedSkills));
        }, (error) => console.log("error"));

        this.getCurriculums = () => {
            return ((this.isAdmin || this.isManager) ? curriculumService.list() : curriculumService.listNoLegacy()).then(data => {
                this.curriculums = data;
                this.curriculums.forEach(curriculum => {
                    curriculum.areas.forEach(area => {
                        area.grades.forEach(grade => {
                            grade.skills.forEach(skill => {
                                skill.curriculumName = curriculum.name;
                                skill.gradeName = grade.name;
                                skill.areaName = area.name;
                            });
                        })
                    })
                });
                this.filteredSkills();
            });
        };

        this.getCurriculums();

        this.handleSaveSubjectAreaClick = (skills, id, redirect) => {
            if(id) {
                const learningGoals = [];
                skills.forEach(skill => {
                    if(skill.importance) {
                        learningGoals.push({
                            skillId: skill.skillId ? skill.skillId : skill.id,
                            importance: skill.importance
                        });
                    }
                });

                this.stateChangeCheck = false;
                stepLearningGoalsService.saveLearningGoals({learningGoals: learningGoals, areaId: 0}, this.evaluationId).then(() => {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Basic information data has been saved successfully')
                            .position('top center')
                            .action('Hide')
                            .highlightAction(true)
                            .hideDelay(4000)
                            .toastClass('success-toast')
                    );
                    if(redirect) {
                        $state.go(`mini.learningGoals.defaultSubjectArea`, {
                            id: this.evaluationData.id,
                            subjectAreaId: this.learningAreas[0].id
                        });
                    }
                }).catch((err) => {
                    $mdDialog.show(
                        $mdDialog.alert({
                            title: 'Some error occurred',
                            textContent: `Your data has not been saved. Please try again.`,
                            ok: 'OK',
                        })
                    );
                });
            } else {
                this.submitted = true;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('You need to fill Subject Area in Basic information before going to the next step.')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass("error-toast")
                );
            }
        };

        this.showEditSkillsPrompt = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'editSkillsDialog.tmpl.html',
                parent: angular.element(document.body),
                fullscreen: true,
                multiple: true,
                locals: {
                    areaid: this.evaluationData.subjectAreaId
                },
                controller: function DialogController($scope, $mdDialog, areaid) {
                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };
                    $scope.areaid = areaid;
                }
            })
            .then(function() {
                this.getCurriculums();
            }, function() {});
        };
    }

    changeExcludeField(skillId, excludeStatus) {
        this.stepLearningGoalsService.updateExcludeField(this.evaluationId, skillId, excludeStatus);
    }

    filteredSkills() {
        const groupedSkills = [];
        const sortedSelectedSkills = [];
        this.selectedSkills.forEach(skill => {
            let group = groupedSkills.find(group => group.curriculum === skill.curriculumName
               && group.grade === skill.gradeName
               && group.area === skill.areaName);
            if (group) {
                group.skills.push(skill);
            } else {
               group = {
                   curriculum: skill.curriculumName,
                   grade: skill.gradeName,
                   area: skill.areaName,
                   skills: [skill],
               };
               groupedSkills.push(group);
            }
        });

        this.groupedSkills = groupedSkills;
        this.groupedSkills.forEach(group => {
            group.skills.forEach(skill => sortedSelectedSkills.push(skill));
        });
        this.selectedSkills = sortedSelectedSkills;
    }

    findSelectedIndex(skill, selectedSkills) {
        return selectedSkills.findIndex(selected => selected.id === skill.id || selected.skillId === skill.id);
    }

    selectSkill(skill, selectedSkills) {
        const idx = this.findSelectedIndex(skill, selectedSkills);

        if (idx > -1) {
            selectedSkills.splice(idx, 1);
        } else {
            selectedSkills.push(skill);
        }
        this.filteredSkills();
    }

    removeSkill(skill, selectedSkills) {
        const idx = this.findSelectedIndex(skill, selectedSkills);
        selectedSkills.splice(idx, 1);
        this.filteredSkills();
    }

    $onDestroy() {
        if (!this.isFinished && this.stateChangeCheck && !angular.equals(this.groupedSkills, this.groupedSkillsPristine)) {
            this.handleSaveSubjectAreaClick(this.selectedSkills, this.evaluationData.subjectAreaId, false);
        }
    }

    defineSelectedSkills(filteredSkills) {
        this.selectedSkills = filteredSkills.map((skill) => {
            this.curriculums.find((curriculum) => {
                return curriculum.areas.find((area) => {
                    return area.grades.find((grade) => {
                        if (grade.id === skill.gradeId) {
                            skill.gradeName = grade.name;
                            skill.curriculumName = curriculum.name;
                            skill.areaName = area.name;
                            skill.exclude = this.evaluationData.learningGoalsExclude
                                .some(exclude => exclude.skillId === skill.skillId && exclude.exclude === '1');
                            return skill;
                        }
                    });
                });
            });
            return skill;
        });
    }
}

export default SubjectAreaController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/pages/subjectArea/subjectAreaController.js